 import loginModal from "@/components/modals/loginModal/loginModal.vue";
import signUpModal from "@/components/modals/signUpModal/signUpModal.vue";
import CustomInput from "@/components/CustomInput/CustomInput.vue";
import successModal from "@/components/modals/successModal/successModal.vue";
import {mapGetters} from "vuex";

export default {
    name: "RequirementRegister",
    components: {loginModal,CustomInput,signUpModal,successModal},
    data() {
        return {
            showLoginModal: true,
            showSuccessModal: false,
            showSignUpModal: false,
            headerFixed: false,
            showMobileMenu: false,
            closeBurgerMenu: false,
        }
    },
    props: {
        messagePassword: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        ...mapGetters(['toogleLogin', 'toogleSignUp', 'toogleSuccess', 'isLoggedIn', 'userInfo']),
    },
    methods: {
        toSignUp: function() {
            this.modalActiveSign = 'signup';
            this.$store.dispatch('changeVisionLogin');
            this.$store.dispatch('changeVisionSignUp');
        },
        toLogin: function () {
            this.modalActiveSign = 'login'
            this.$store.dispatch('changeVisionSignUp')
            this.$store.dispatch('changeVisionLogin')
        },
        toogleLoginModal(){
            this.$store.dispatch('changeVisionLogin')
        },
        toogleSuccessModal(){
            this.$store.dispatch('changeVisionSuccess')
        },
        toogleSignUpModal(){
            this.$store.dispatch('changeVisionSignUp')
        }
    },
    created() {
        this.$store.dispatch('hideAllModals')
        this.$store.dispatch('changeVisionLogin')
    }
}
